/** @flow */
import * as React from 'react';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Chip from '@material-ui/core/Chip';
import MenuItem from '@material-ui/core/MenuItem';
import CancelIcon from '@material-ui/icons/Cancel';
import Select from 'react-select';
import styled from 'styled-components';
import { translate } from 'react-i18next';

const NoOptionsWrapper = styled(Typography)`
  padding: ${props => props.theme.V2.metrics.margin.normal}px ${props => props.theme.V2.metrics.margin.large}px;
  color: ${props => props.theme.V2.colors.text.secondary};
`;

function NoOptionsMessage(props) {
  return <NoOptionsWrapper {...props.innerProps}>{props.children}</NoOptionsWrapper>;
}

const Input = styled.div`
  display: flex;
  padding: 0;
`;

function inputComponent({ inputRef, ...props }) {
  return <Input ref={inputRef} {...props} />;
}

function Control(props) {
  return (
    <TextField
      fullWidth
      InputProps={{
        inputComponent,
        inputProps: {
          inputRef: props.innerRef,
          children: props.children,
          ...props.innerProps,
        },
      }}
      {...props.selectProps.textFieldProps}
    />
  );
}

function Option(props) {
  return (
    <MenuItem
      buttonRef={props.innerRef}
      selected={props.isFocused}
      component="div"
      {...props.innerProps}
    >
      {props.children}
    </MenuItem>
  );
}

const PlaceHolderWrapper = styled.div`
  position: absolute;
  left: 2px;
  color: ${props => props.theme.V2.colors.text.secondary};
  font-size: ${props => props.theme.V2.fonts.body.size}px;
`;

function Placeholder(props) {
  return <PlaceHolderWrapper {...props.innerProps}>{props.children}</PlaceHolderWrapper>;
}

const SingleValueWrapper = styled(Typography)`
  font-size: ${props => props.theme.V2.font.body.size}px;
`;

function SingleValue(props) {
  return <SingleValueWrapper {...props.innerProps}>{props.children}</SingleValueWrapper>;
}

const SValueContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  align-items: center;
  overflow: hidden;
`;

function ValueContainer(props) {
  return <SValueContainer>{props.children}</SValueContainer>;
}

const SChips = styled(Chip)`
  margin: ${props => props.theme.V2.metrics.margin.tiny}px ${props => props.theme.V2.metrics.margin.tiny}px;
`;

function MultiValue(props) {
  return (
    <SChips
      tabIndex={-1}
      label={props.children}
      onDelete={props.removeProps.onClick}
      deleteIcon={<CancelIcon {...props.removeProps} />}
    />
  );
}

const SPaper = styled(Paper)`
  position: absolute;
  z-index: 99999;
  left: 0;
  right: 0;
  margin-top: ${props => props.theme.V2.metrics.margin.small}px;
`;

function Menu(props) {
  return <SPaper square {...props.innerProps}>{props.children}</SPaper>;
}

const components = {
  Control,
  Menu,
  MultiValue,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer,
};

export interface MultiSelectOption {
  label: string;
  value: any;
}

interface Props {
  options: MultiSelectOption[];
  placeholder: string;
  value: MultiSelectOption | MultiSelectOption[];
  onChange: () => void;
  noMoreOptionsMessage: string;

  multiple?: boolean;
  autocomplete?: boolean;
  disabled?: boolean;
  notFoundMessage?: string;

  t: (key: string) => string;
}

class MultiSelectComponent extends React.Component<Props> {

  makeNoOptionsMessage = (data) => {
    const { notFoundMessage, noMoreOptionsMessage, t } = this.props;
    if (data.inputValue === '') {
      return noMoreOptionsMessage;
    }

    if (notFoundMessage) {
      return notFoundMessage;
    }

    return t('noResult');
  }

  render() {
    const { options, placeholder, multiple, value, onChange, autocomplete, disabled } = this.props;

    return (
      <Select
        options={options}
        components={components}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        noOptionsMessage={this.makeNoOptionsMessage}
        isMulti={multiple}
        isSearchable={autocomplete}
        isDisabled={disabled}
        closeMenuOnSelect={false}
      />
    );
  }
}

export const MultiSelect = translate()(MultiSelectComponent);



// WEBPACK FOOTER //
// ./src/common/components/MultiSelect.js